// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__O0qnF","option":"styles_option__vr8k5","active":"styles_active__2jv3z"};